import { environment } from '../environments/environment'

export const baseUrl = environment.baseUrl
export const apiUrl = environment.apiUrl
export const imageUrl = environment.imageUrl
export const imageStatusUrl = environment.imageStatusUrl
export const versionApp = environment.versionApp
export const versionWeb = environment.versionWeb
export const versionApi = environment.versionApi

export const tokenDeviceUrl = '/client/activation/'
export const linkAndroidStore = environment.device.androidStoreUrl
export const linkAppleStore = environment.device.iosStoreUrl
export const urlScheme =
    environment.device.urlScheme + '/app/client.html#/activation/'

export const baseUrlGMO = environment.gmo.callbackUrl

export const ordinalSuffixOf = (i) => {
    var j = i % 10,
        k = i % 100
    if (j == 1 && k != 11) {
        return i + 'st'
    } else if (j == 2 && k != 12) {
        return i + 'nd'
    } else if (j == 3 && k != 13) {
        return i + 'rd'
    } else if (j > 3) {
        return i + 'th'
    } else if (i == 'counseling') {
        return 'Counseling'
    } else if (i == 'pre') {
        return 'Pre'
    } else if (i == 'retainer') {
        return 'Retainer'
    } else if (i == 'followUp') {
        return 'Follow Up'
    } else {
        return i
    }
}

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item)
}

/**
 * Deep merge two objects.
 * @param target
 * @param sources
 */
export function mergeDeep(target, ...sources) {
    if (!sources.length) return target
    const source = sources.shift()

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} })
                mergeDeep(target[key], source[key])
            } else {
                Object.assign(target, { [key]: source[key] })
            }
        }
    }

    return mergeDeep(target, ...sources)
}

/**
 *
 * @param url
 * @param withBaseUrl
 */
export function getImageStatusUrl(digest, withBaseUrl = false) {
    const statusUrl = imageUrl.replace('redirect', 'status')
    return `${ statusUrl }${ digest }`
}

/**
 *
 * @param degist
 * @param type
 */
export function getImageRedirectUrl(digest, type = '') {
    const baseUrl = `${ environment.imageRedirectUrl }/${ digest }`
    if (type) {
        return `${ baseUrl }?type=${ type }`
    } else {
        return baseUrl
    }
}

export function getPdfRedirectUrl(digest) {
    const baseUrl = `${ environment.imageRedirectUrl }/${ digest }`
    return baseUrl.replace('redirect', 'status')
}

export function getVideoRedirectUrl(digest) {
    return `${ environment.imageRedirectUrl }/${ digest }`
}

export function getThumbnail(digest) {
    return `${ environment.imageRedirectUrl }/${ digest }_thumb`
}

/**
 * Check object is null or undefined
 * @param value
 */
export function isNullOrUndefined(value) {
    return value === undefined || value === null
}

/**
 * Check object is null or undefined
 * @param value
 */
export function undefinedIsTrue(value) {
    return value === undefined ? true : !!value
}

export function handleImageError(currentUrl) {
    const urlSerializer = new URL(currentUrl)
    try {
        if (!urlSerializer.searchParams.has('type')) {
            return
        }
        const currentType = urlSerializer.searchParams.get('type')
        switch (currentType) {
            case 'large':
                urlSerializer.searchParams.set('type', 'xlarge')
                break
            case 'xlarge':
                urlSerializer.searchParams.set('type', 'other')
                break
            case 'other':
                urlSerializer.searchParams.set('type', 'medium')
                break
        }
        currentUrl = urlSerializer.toString()
        if (currentType === 'medium') {
            return currentUrl.replace('?type=medium', '')
        }
        return currentUrl
    } catch (error) {
        return currentUrl.replace('?type=medium', '')
    }
}

export function checkImageExists(url): Promise<boolean> {
    return new Promise((resolve) => {
        const img = new Image()
        img.onload = function() {
            console.debug('image exist', url)
            resolve(true)
        }
        img.onerror = function() {
            console.debug('image do not exist', url)
            resolve(false)
        }
        img.src = url
    })
}

/**
 *
 * @param dataurl
 * @param filename
 */
export function dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
}

export function mongoObjectId(): string {
    const timestamp = ((new Date().getTime() / 1000) | 0).toString(16)
    return (
        timestamp +
        'xxxxxxxxxxxxxxxx'
        .replace(/[x]/g, function() {
            return ((Math.random() * 16) | 0).toString(16)
        })
        .toLowerCase()
    )
}



// WEBPACK FOOTER //
// ./src/helper/common.ts